import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { AppDispatch } from "./app/features/template/store";
import { templateStructureInfo } from "./templateSlice";
import { useDispatch } from "react-redux";

export const getTemplateList = createAsyncThunk(
  "template/gettemplateList",
  async (_, { dispatch }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_GATEWAY_HOST}/api/pdf-parser/template/list`
      );

      dispatch(templateStructureInfo(response.data));

      const options = response.data.map((item: any) => ({
        value: item.id,
        text: item.templateName,
      }));
      options.sort((a:any, b:any) => (a.text > b.text ? 1 : -1));

      return options;
    } catch (error) {
      console.error(error);
      return []; // return consistent data structure
    }
  }
);
export const getTemplateInfobyID = createAsyncThunk(
  "template/getTemplatebyID",
  async (id:string, { dispatch }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_GATEWAY_HOST}/api/pdf-parser/template/${id}`
      );

      dispatch(templateStructureInfo(response.data));

     

      return response;
    } catch (error) {
      console.error(error);
      return []; // return consistent data structure
    }
  }
);
export const getTemplateParseByFieldName = createAsyncThunk(
  "template/getTemplateParse",
  async (payload: any, { dispatch }) => {
    try {
      // Creating form data to handle file upload
      const formData = new FormData();
      formData.append('file', payload.file); // Assuming payload.file contains the actual file
      
 
      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEWAY_HOST}/api/pdf-parser/template/parse/field?templateName=${payload.selectedTemplate}&fieldName=${payload.selectedField}`, // Changed to match the endpoint in screenshot
        formData,
    
      );
      
      return response;
    } catch (error) {
      console.error("Template parse error:", error);
      throw error; // Better to throw the error so the rejected action is dispatched
    }
  }
);
export const getTemplateParse = createAsyncThunk(
  "template/getTemplateParse",
  async (payload: any, { dispatch }) => {
    try {
      // Creating form data to handle file upload
      const formData = new FormData();
      formData.append('file', payload.file); // Assuming payload.file contains the actual file
      
 
       const response = await axios.post(
        `${process.env.REACT_APP_API_GATEWAY_HOST}/api/pdf-parser/template/parse?templateName=${payload.selectedTemplate}`, // Changed to match the endpoint in screenshot
        formData,
    
      ); 
    
      return response;
    } catch (error) {
      console.error("Template parse error:", error);
      throw error; // Better to throw the error so the rejected action is dispatched
    }
  }
);
export const validateIdentifers = createAsyncThunk(
  "template/validateIdentifers",
  async (payload: any, { dispatch }) => {
    try {
      // Creating form data to handle file upload
      const formData = new FormData();
      formData.append('file', payload.file); // Assuming payload.file contains the actual file
      
 
      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEWAY_HOST}/api/pdf-parser/template/validateIdentifers?templateName=${payload.selectedTemplate}`, // Changed to match the endpoint in screenshot
        formData,
    
      );
      
      return response;
    } catch (error) {
      console.error("Template parse error:", error);
      throw error; // Better to throw the error so the rejected action is dispatched
    }
  }
);
export const readTemplate = createAsyncThunk(
  "template/readTemplate",
  async (payload: any, { dispatch }) => {
    try {
      // Creating form data to handle file upload
      const formData = new FormData();
      formData.append('file', payload.file); // Assuming payload.file contains the actual file
      
 
      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEWAY_HOST}/api/pdf-parser/template/read`,
        formData,
    
      );
      
      return response;
    } catch (error) {
      console.error("Template parse error:", error);
      throw error; // Better to throw the error so the rejected action is dispatched
    }
  }
);
export const addTemplate = createAsyncThunk(
  "template/addTemplate",
  async (payload: any, { dispatch }) => {
    try {
   
 
      const response = await axios.post(
        `${process.env.REACT_APP_API_GATEWAY_HOST}/api/pdf-parser/template`,
      payload
      );
      
      return response;
    } catch (error) {
      console.error("Template parse error:", error);
      throw error; // Better to throw the error so the rejected action is dispatched
    }
  }
);
export const updateTemplate = createAsyncThunk(
  "template/updateTemplate",
  async (payload: any, { dispatch }) => {
    try {
   
 
      const response = await axios.put(
        `${process.env.REACT_APP_API_GATEWAY_HOST}/api/pdf-parser/template`,
      payload
      );
      
      return response;
    } catch (error) {
      console.error("Template parse error:", error);
      throw error; // Better to throw the error so the rejected action is dispatched
    }
  }
);
export const getapp = createAsyncThunk(
  "template/app",
  async (_, { dispatch }) => {
    try {
   
 
      const response = await axios.get(
        `${process.env.REACT_APP_API_GATEWAY_HOST}/api/pdf-parser/app`
      
      );
      
      return response;
    } catch (error) {
      console.error("Template parse error:", error);
      throw error; // Better to throw the error so the rejected action is dispatched
    }
  }
);

export const templateDelete = createAsyncThunk(
  "template/templateDelete",
  async (id:string, { dispatch }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_GATEWAY_HOST}/api/pdf-parser/template/${id}`
      );
      dispatch(templateStructureInfo(response.data));

      return response;
    } catch (error) {
      console.error(error);
      return []; // return consistent data structure
    }
  }
);